/* ***************************************************************** */
/* TODO: eslint pre-existing exceptions auto generated on 2022-09-08 */
/*       Do not add to these rule exceptions. Only remove as the     */
/*       violations are cleaned from our code.                       */
/*                                                                   */
/*       eslint-disable no-shadow                                    */
/*       eslint-disable no-restricted-syntax                         */

/* ***************************************************************** */
/* TODO: fix this 👇 */

import React, { useState } from 'react';
import { connect } from 'react-redux';
import { CircularProgress, Button } from '@mui/material';
import {
  getYieldUploadUrl,
  getYieldDownloadUrl,
  uploadYieldToS3,
  uploadYieldToAgi,
} from '../../lib/api';
import ClipboardContainer from '../../components/ClipboardContainer/ClipboardContainer';
import LinearProgressWithLabel from '../../components/LinearProgressWithLabel/LinearProgressWithLabel';
import { Dropzone } from '../../components/Dropzone';
import { Section } from '../Section';

const YieldUpload = ({ growerOperation }) => {
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [uploads, setUploads] = useState(null);

  const updateFiles = (files) => {
    setFiles(files);
  };

  const handleUploadProgress = (fileName, progressEvent) => {
    const pct = (progressEvent.loaded / progressEvent.total) * 100;

    setUploads((prevUploads) => {
      const upload = prevUploads ? prevUploads[fileName] || {} : {};

      return {
        ...prevUploads,
        [fileName]: {
          ...upload,
          percent: pct,
        },
      };
    });
  };

  const uploadFiles = async (e) => {
    e.preventDefault();

    const growerId = growerOperation.guid;

    setIsLoading(true);
    const uploadFiles = files.reduce(
      (acc, cur) => ({
        ...acc,
        [cur.name]: {
          name: cur.name,
          percent: 0,
          jobId: '',
          error: '',
          step: 'Waiting',
        },
      }),
      {},
    );
    setUploads(uploadFiles);

    for (const file of files) {
      setUploads((prevUploads) => ({
        ...prevUploads,
        [file.name]: {
          ...prevUploads[file.name],
          step: 'Uploading file to S3',
        },
      }));
      const yieldUploadUrl = await getYieldUploadUrl(growerId, file.name);
      await uploadYieldToS3(yieldUploadUrl, file, handleUploadProgress);
      const yieldDownloadUrl = await getYieldDownloadUrl(growerId, file.name);

      setUploads((prevUploads) => ({
        ...prevUploads,
        [file.name]: {
          ...prevUploads[file.name],
          step: 'Sending request to yield service',
        },
      }));
      const serviceResult = await uploadYieldToAgi(
        growerId,
        yieldDownloadUrl,
        file.name,
      );

      setUploads((prevUploads) => ({
        ...prevUploads,
        [file.name]: {
          ...prevUploads[file.name],
          jobId: serviceResult.job,
          error: serviceResult.message,
          step: 'Complete',
        },
      }));
    }

    setIsLoading(false);
  };

  return (
    <Section>
      <Dropzone
        onChange={updateFiles}
        contentType="yield data"
        fileType="zip"
        isUploading={isLoading}
      />
      {isLoading ? (
        <div style={{ paddingTop: '10px', textAlign: 'center' }}>
          <CircularProgress
            style={{ top: '10px', display: 'block', margin: 'auto' }}
          />
        </div>
      ) : (
        <div style={{ paddingTop: '25px' }}>
          <Button
            variant="outlined"
            color="inherit"
            style={{ display: 'block', margin: 'auto' }}
            disabled={files.length === 0}
            onClick={uploadFiles}
          >
            Upload
          </Button>
        </div>
      )}
      {Object.keys(uploads || {}).map((fileName) => (
        <div key={fileName} style={{ padding: '25px' }}>
          <div>{fileName}</div>
          <div>Status: {uploads[fileName].step}</div>
          <LinearProgressWithLabel value={uploads[fileName].percent} />
          {uploads[fileName].jobId ? (
            <div style={{ paddingTop: '10px', textAlign: 'center' }}>
              File uploaded with a Job ID:{' '}
              <ClipboardContainer
                value={uploads[fileName].jobId}
                isValueVisible={true}
              />
            </div>
          ) : null}
          {uploads[fileName].error ? (
            <div>
              File failed to process. The server responded with the following
              error:{' '}
              <ClipboardContainer
                value={uploads[fileName].error}
                isValueVisible={true}
              />
            </div>
          ) : null}
        </div>
      ))}
    </Section>
  );
};

const mapStateToProps = (state) => ({
  growerOperation: state.growerOperations.selectedGrowerOperation,
});

export default connect(mapStateToProps)(YieldUpload);
